import { GraphQLClient } from 'graphql-request';
import { GetProfileImageUploadUrlInput, Mutation } from '../generated/graphql';
import { gql } from 'urql';

export const clientGetProfileImageUploadUrl = async (client: GraphQLClient, input: GetProfileImageUploadUrlInput) => {
  const res = await client.request<Pick<Mutation, 'getProfileImageUploadURL'>>(
    gql`
      mutation GetProfileImageUploadUrl($input: GetProfileImageUploadURLInput!) {
        getProfileImageUploadURL(input: $input) {
          uploadURL
        }
      }
    `,
    { input }
  );
  return res.getProfileImageUploadURL.uploadURL;
};
